export enum Locale {
    ENGLISH = 'en',
    CHINESE = 'zh',
}
